<template>
<div class="font-roboto">
    <Breadcrumbs main="" :title="$t('lbl_EMPBE_AutoReport')" />
    <div class="Wrapper">
        <DataGrid></DataGrid>
    </div>

</div>
</template>

<script>

import DataGrid from "./component/grid";

export default{
    components:{
        DataGrid
    }
}
</script>

<style lang="scss">
  @import "./style/default"; 
</style>
